import { useMemo, useState } from 'react';
import { ProductCard } from '../components/ProductCard';
import { useCatalog } from '../lib/catalog';

export function MarketplacePage() {
  const { products, loading, error } = useCatalog();
  const [filter, setFilter] = useState('All');

  const filters = useMemo(() => {
    const cats = Array.from(new Set(products.map((p) => p.category).filter(Boolean)));
    return ['All', ...cats];
  }, [products]);

  const list = useMemo(() => {
    if (filter === 'All') return products;
    return products.filter((p) => p.category === filter);
  }, [filter, products]);

  return (
    <div className="container">
      <div className="page-hero">
        <span className="eyebrow">Bizi Marketplace</span>
        <h1>
          Digital products for <span className="gradient-text">EspoCRM champions</span>
        </h1>
        <p>
          Production-ready extensions from Bizi Office — published from our CRM catalog, not hardcoded into
          the site. Secure checkout via Stripe™. Instant fulfillment on success.
        </p>
        <div className="market-toolbar">
          {filters.map((f) => (
            <button key={f} className={`chip ${filter === f ? 'active' : ''}`} onClick={() => setFilter(f)}>
              {f}
            </button>
          ))}
        </div>
      </div>

      {loading && <p className="muted">Loading the roster from Bizi Office CRM…</p>}
      {error && (
        <div className="card checkout-panel">
          <h2>Catalog is warming up</h2>
          <p className="muted">{error}</p>
        </div>
      )}
      {!loading && !error && list.length === 0 && (
        <p className="muted">No published extensions yet. Check back after the next play.</p>
      )}

      <div className="product-grid">
        {list.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </div>
  );
}
